import { render, staticRenderFns } from "./PercentageCard.vue?vue&type=template&id=7865db9a&scoped=true&"
import script from "./PercentageCard.vue?vue&type=script&lang=js&"
export * from "./PercentageCard.vue?vue&type=script&lang=js&"
import style0 from "./PercentageCard.vue?vue&type=style&index=0&id=7865db9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7865db9a",
  null
  
)

export default component.exports